import styled from "styled-components";

export const Container = styled.div`
  width: 100%;

  height: 88.8vh;
  text-align: center;
  ::-webkit-scrollbar {
    display: none;
  }
  a {
    text-decoration: none;
    color: black;
  }
  @media (max-width: 800px) {
    height: 90.5vh;
    background: powderblue;
    overflow-y: hidden;
  }
`;

export const Card = styled.div`
  padding: 3% 3%;
  background: white;
  display: grid;
  grid-template-columns: 50% 50%;
  text-align: left;
  border: 1px solid whitesmoke;
  justify-content: space-between;
  img {
    width: 100%;
    border-radius: 10px;
  }
  hr {
    width: 10%;
    margin-left: -1%;
  }

  @media (max-width: 800px) {
    display: block;
    padding: 3% 3%;
    margin: 0 2%;
    height: 145px;
    line-height: 1;
    padding: 5%;
    flex-basis: 80%;
    border-radius: 10px;
    border: none;
    box-shadow: 1px 1px 3px #aaaaaa;
    flex-grow: 0;
    flex-shrink: 0;
    img {
      display: none;
    }
  }
`;

export const Content = styled.div`
  width: 100%;
  h3 {
    font-size: 18px;
    margin: 0;
    font-weight: 300;
  }
  p {
    font-size: 14px;
  }
  @media (max-width: 800px) {
    h3 {
      font-weight: 600;
      font-size: 14px;
    }
  }
`;

export const Icons = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  p {
    margin-right: 6.9%;
    font-size: 14px;
  }
  img {
    display: block !important;
    margin-right: 1%;
    margin-top: -1.8%;
    width: 15px !important;
    height: 15px;
  }
`;

export const ResultContainer = styled.div`
  display: flex;
  width: 100%;
  margin: 0;
  height: 100%;

  .results {
    background: white;
    position: relative;
    width: 55%;
    height: 100%;
    margin: 0;
    overflow-y: scroll;
  }

  @media (max-width: 800px) {
    display: block;
    position: relative;

    .results {
      position: relative;
      z-index: 5;
      &::-webkit-scrollbar {
        display: none;
      }
      width: 100%;
      height: 230px;
      background: rgba(255, 255, 255, 0);
      top: 52vh;
      overflow-x: auto;
      overflow-y: hidden;
      display: flex;
    }
  }
`;

export const Empty = styled.p`
  margin: 0 auto;
  color: black;
`;

export const Loader = styled.span`
  .loader-item {
    width: 85%;
    margin: 15px 0;
    height: 250px !important;
  }
  @media (max-width: 800px) {
    &::-webkit-scrollbar {
      display: none;
    }
    width: 100%;
    height: 100%;
    overflow-x: scroll;
    overflow-y: hidden;
    white-space: nowrap;
    .loader-item {
      width: 80%;
      display: inline-block;
      margin: 0 2%;
      border-radius: 10px;
      margin-top: 5%;
      padding: 0;
      opacity: 0.9;
      height: 160px !important;
    }
  }
`;
